import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';

export default class ChatRecord extends RecordBase {
  static defaultAttributes = {
    subject: '',
    user_from:  null,
    specialty:  null,
    not_readed:  0,
    user_from_name:  '',
    user_to: null,
    user_to_name: '',
    is_closed: false,
    messages: null,
    created_at: '',
    updated_at: '',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`chats.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        subject: trAttr('subject'),
        specialty: trAttr('specialty'),
        user_from: trAttr('user_from'),
        not_readed: trAttr('not_readed'),
        user_from_name: trAttr('user_from_name'),
        user_to: trAttr('user_to'),
        user_to_name: trAttr('user_to_name'),
        messages: trAttr('messages'),
        is_closed: trAttr('is_closed'),
        created_at: trAttr('created_at'),
        updated_at: trAttr('updated_at'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      subject,
      user_from,
      specialty,
      not_readed,
      user_from_name,
      user_to,
      user_to_name,
      is_closed,
      created_at,
      updated_at,
    } = this.toObject();
    return {
      data:{
        attributes:{
          subject,
          user_from_id: dig(user_from, 'id'),
          specialty_id: dig(specialty, 'id'),
          not_readed,
          user_from_name,
          user_to_id: dig(user_to, 'id'),
          user_to_name,
          is_closed,
          created_at,
          updated_at,
          ...attrs
        }
      }
    };
  }
}
